var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subtasks-area"},_vm._l((_vm.history),function(subTask,i){return _c('task-card',{key:i,staticClass:"mt-3",attrs:{"fromHistory":true,"isGeneral":true,"validation":subTask.validation_state,"info":subTask,"index":i}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }